import Route from '@ember/routing/route';

export default class HotelStrategyRoomtypeRoute extends Route {
  queryParams = {
    sortBy: {
      refreshModel: false,
    },
    sortDirection: {
      refreshModel: false,
    },
    tab: {
      refreshModel: false,
    },
    roomtype: {
      refreshModel: false,
    },
  };
}
